import { render, staticRenderFns } from "./showPill.vue?vue&type=template&id=5e7da304&scoped=true"
import script from "./showPill.vue?vue&type=script&lang=js"
export * from "./showPill.vue?vue&type=script&lang=js"
import style0 from "./showPill.vue?vue&type=style&index=0&id=5e7da304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7da304",
  null
  
)

export default component.exports